import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { useEffect, useMemo, useRef, useState } from 'react'

dayjs.extend(utc)

export const useProgress = ({ date }: { date: string }) => {
  const [now, setNow] = useState(dayjs().utc())
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const progress = useMemo(() => {
    const givenDate = dayjs(date).utc()
    const diffInSeconds = now.diff(givenDate, 'second')
    const progress = Math.min((diffInSeconds / 100) * 90, 100)

    return progress
  }, [date, now])

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      if (progress >= 100 && intervalRef.current) {
        clearInterval(intervalRef.current)
        return
      }

      setNow(dayjs().utc())
    }, 1000)

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [progress])

  return { progress }
}
